var getIgnitionIcon =  function(val) {
    switch (val) {
        case 1: // зажигание не активно
            return '<i class="icon-Starter" style="margin-left: 4px;font-size: 14px;padding-right: 2px;color: lightgrey;" id="ext-element-1056"></i>';
        case 2: // зажигание активно
            return '<i class="icon-Starter" style="margin-left: 4px;font-size: 14px;padding-right: 2px;color: #2AD000;" id="ext-element-1056"></i>';
        default:
            return '';
    }
}

export default getIgnitionIcon;


// WEBPACK FOOTER //
// ./app/icon-ignition.js